import { Route } from '@angular/router';
import { experienceVisibilityGuard } from '@rma/dashboard/layout/public/api-experience';
import { awardsRoutes } from './awards.routes';
import { googleProfileRoutes } from './google-profile.routes';
import { socialMediaRoutes } from './social-media.routes';

export const shareRoutes: Route[] = [
  {
    path: 'awards',
    children: awardsRoutes,
  },
  {
    path: 'google-profile',
    children: googleProfileRoutes,
  },
  {
    path: 'market-reports',
    loadChildren: () => import('@rma/dashboard/market-reports/market-reports'),
  },
  {
    path: 'integrations',
    loadChildren: () => import('@rma/dashboard/integrations/integration-hub'),
  },
  {
    path: 'socialmedia',
    canActivate: [experienceVisibilityGuard((s) => s.showSocialMediaManager$)],
    children: socialMediaRoutes,
  },
  {
    path: 'widgets',
    loadChildren: () => import('@rma/dashboard/integrations/widgets'),
  },
];
